"use client";

import BreadcrumbComp from "@/components/shared/BreadcrumbComp";
import { Pagination } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineClockCircle } from "react-icons/ai";
import { motion } from "framer-motion";
import Link from "next/link";

import NewsItem from "./NewsItem";
import useFetchApi from "@/hooks/useFetchApi";

function NewsIndex({
  news: dataNews,
  newsPinned: highLightNews,
  pagination: dataPagination,
}) {
  const [news, setNews] = useState(dataNews || []);
  const [pagination, setPagination] = useState(dataPagination || {});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isFisrstLoad, setIsFirstLoad] = useState(true);
  const {
    data,
    errors,
    triggerFetch: loadMoreList,
  } = useFetchApi({
    url: "/news",
    params: {
      page: page,
      isHighLight: false,
    },
    skip: true,
  });

  useEffect(() => {
    if (!isFisrstLoad) {
      setNews(data?.data?.news || []);
      setPagination(data?.data?.pagination || {});
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, [dataPagination]);

  useEffect(() => {
    if (!isFisrstLoad) {
      loadMoreList();
    }
  }, [page]);

  const loadMore = useCallback((p) => {
    setLoading(true);
    setPage(p);
  }, []);

  const breadcrumbs = [
    { title: "Trang Chủ", href: "/" },
    { title: "Tin Tức", href: "/tin-tuc" },
  ];
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("vi-VN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="bg-white pb-20">
      <div className="section mx-auto">
        <BreadcrumbComp items={breadcrumbs} />

        <h1 className="text-center text-4xl font-bold my-10">Tin Tức</h1>

        {/* Tin Hot Section */}
        {highLightNews.length ? (
          <motion.div
            initial={{ y: 50, opacity: 0 }} // Trạng thái ban đầu (dưới 50px)
            whileInView={{ y: 0, opacity: 1 }} // Khi cuộn tới thì trượt lên
            viewport={{ once: true }} // Chỉ chạy 1 lần
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="mb-16"
          >
            <h2 className="text-2xl font-bold mb-6">Tin Hot</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Left: Big Feature */}
              <Link href={`/tin-tuc/${highLightNews[0].id}`}>
                <div className="group cursor-pointer">
                  <div className="w-full aspect-[16/9] overflow-hidden mb-4">
                    <img
                      src={highLightNews[0].thumbnail}
                      alt={highLightNews[0].title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>
                  <div className="flex items-center gap-2 text-[#999] text-sm mb-3">
                    <AiOutlineClockCircle color="#06B6D4" />
                    <span className="text-[#06B6D4]">
                      {formatDate(highLightNews[0].createdAt)}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#333] mb-3 group-hover:text-[#E5C383] transition-colors">
                    {highLightNews[0].title}
                  </h3>
                  <p className="text-[#666] line-clamp-3">{highLightNews[0].description}</p>
                </div>
              </Link>

              {/* Right: List */}
              <div
                className={`flex flex-col gap-6 ${highLightNews.slice(1).length >= 3
                  ? "max-h-[600px] overflow-y-auto pr-2"
                  : ""
                  }`}
              >
                {highLightNews.slice(1).map((item, index) => (
                  <NewsItem key={index} item={item} type="horizontal" />
                ))}
              </div>
            </div>
          </motion.div>
        ) : undefined}
        {/* <div className="mb-16 animate-slide-up">
                    
                </div> */}

        {/* Tin Mới Section */}
        <motion.div
          initial={{ y: 50, opacity: 0 }} // Trạng thái ban đầu (dưới 50px)
          whileInView={{ y: 0, opacity: 1 }} // Khi cuộn tới thì trượt lên
          viewport={{ once: true }} // Chỉ chạy 1 lần
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <h2 className="text-2xl font-bold mb-6">Tin Mới</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
            {news.map((item, index) => (
              <NewsItem key={index} item={item} />
            ))}
          </div>

          <div className="flex justify-end">
            <Pagination
              onChange={loadMore}
              defaultCurrent={pagination.page || 1}
              total={pagination.total}
              showSizeChanger={false}
              pageSize={pagination?.perPage || 10}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default NewsIndex;
